"use client";

import { GET_NAVBAR_QUERYResult } from "@/sanity/sanity.types";
import { FlagGreatBritain, FlagSweden } from "@tingshusethullaryd/icons";
import Link from "next/link";
import { useParams } from "next/navigation";
import useFindTranslation from "./useFindTranslation";

export default function LanguageSwitcher({
  items,
}: {
  items:
    | NonNullable<NonNullable<GET_NAVBAR_QUERYResult>["mainNav"]>["items"]
    | undefined
    | null;
}) {
  const params = useParams();
  const { en, sv } = useFindTranslation(items);

  const isCurrentlyEnglish = params.lang === "en";
  const targetLanguage = isCurrentlyEnglish ? "sv" : "en";
  const targetSlug = isCurrentlyEnglish ? sv : en;
  const targetLabel = isCurrentlyEnglish ? "Svenska" : "English";

  // Check if we're on the homepage - if there's no slug or slug is empty, we're on homepage
  const currentSlug = Array.isArray(params?.slug)
    ? params?.slug?.join("/")
    : params?.slug;

  const isHomepage = !currentSlug || currentSlug === "";

  // If this is a homepage, link to root, otherwise use the normal translation logic
  const href = isHomepage
    ? `/${targetLanguage}`
    : `/${targetLanguage}/${targetSlug}`;

  return targetSlug ? (
    <nav
      className="flex items-center gap-2"
      role="navigation"
      aria-label="Language selection"
    >
      <Link
        href={href}
        locale={targetLanguage}
        className="py-1 px-2 bg-primary rounded-md outline-2 -outline-offset-1 outline-transparent focus:outline-2 focus:-outline-offset-2 focus:outline-tertiary hover:outline-tertiary transition-colors duration-200"
        aria-label={`Switch to ${targetLabel}`}
        title={`Switch to ${targetLabel}`}
        hrefLang={targetLanguage}
      >
        {isCurrentlyEnglish ? (
          <FlagSweden className="size-6" aria-hidden="true" />
        ) : (
          <FlagGreatBritain className="size-6" aria-hidden="true" />
        )}
        <span className="sr-only">Switch to {targetLabel}</span>
      </Link>
    </nav>
  ) : null;
}
